// extracted by mini-css-extract-plugin
export default {"home":"c-i_cV","home__background":"c-i_cW","home__content":"c-i_cX"};